import React,{useState} from 'react'
import {motion} from 'framer-motion'

const Footer = () => {
  const shareData = {
    title: 'WWSC Free Course: 10 Weeks to Stronger Street Outreach',
    text: 'Join me in this free 10-week email course for frontline workers working with street children. 3 practical lessons per week - field-ready, no fluff!',
    url: window.location.href
  }

  const handleShare = async (platform) => {
    const encodedTitle = encodeURIComponent(shareData.title)
    const encodedText = encodeURIComponent(shareData.text)
    const encodedUrl = encodeURIComponent(shareData.url)

    switch(platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodedText}%20${encodedUrl}`, '_blank')
        break
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`, '_blank')
        break
      case 'email':
        window.location.href = `mailto:?subject=${encodedTitle}&body=${encodedText}%20${encodedUrl}`
        break
      case 'native':
        if (navigator.share) {
          try {
            await navigator.share(shareData)
          } catch (err) {
            console.log('Error sharing:', err)
          }
        }
        break
    }
  }

  return (
    <>
      {/* Share Section - 15% smaller, centered, above footer */}
      <motion.div 
        initial={{opacity: 0, y: 20}} 
        animate={{opacity: 1, y: 0}} 
        transition={{duration: 0.8, ease: "easeOut"}} 
        className="text-center py-3" 
        style={{backgroundColor: '#29425D'}}
      >
        <p className="text-white/90 font-semibold text-xs font-poppins mb-2">
          Help a colleague - Share this free course:
        </p>
        <div className="flex justify-center gap-2">
          <button
            onClick={() => handleShare('whatsapp')}
            className="flex items-center gap-1 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded-md transition-all duration-300 hover:transform hover:scale-105 text-xs font-medium"
          >
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.123-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            WhatsApp
          </button>
          
          <button
            onClick={() => handleShare('facebook')}
            className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-all duration-300 hover:transform hover:scale-105 text-xs font-medium"
          >
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Facebook
          </button>
          
          <button
            onClick={() => handleShare('email')}
            className="flex items-center gap-1 px-3 py-1.5 bg-gray-600 hover:bg-gray-700 text-white rounded-md transition-all duration-300 hover:transform hover:scale-105 text-xs font-medium"
          >
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Email
          </button>
        </div>
      </motion.div>

      {/* Original Footer */}
      <footer className="text-white py-3" style={{backgroundColor: '#29425D'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{opacity: 0}} 
            whileInView={{opacity: 1}} 
            viewport={{once: true}} 
            transition={{duration: 0.8}} 
            className="text-center"
          >
            <p className="text-gray-400 text-xs">
              © 2025 Working With Street Children. All Rights Reserved.
            </p>
          </motion.div>
        </div>
      </footer>
    </>
  )
}

export default Footer